import React from 'react';
import moment from 'moment';

export const cellRendererCheck = (value) => {

  if (!value) return '-';
  return value;
};

export const celldateFormate = (row, value) => {

  if (!value) return '-';
  if (row.file_c_status === "At Risk" || row.file_Current_Status === "At Risk") {
    return (
      <span className='text-danger text-end'>
        {moment(new Date(value)).format('MM/DD/YYYY hh:mm A')}
      </span>
    );
  }
  else
    return (
      <span className='text-end'>
        {moment(new Date(value)).format('MM/DD/YYYY hh:mm A')}
      </span>
    );
};

export const currencyFormat = (value) => {

  if (!value || isNaN(value)) return '-';
  if (value < 0)
    return (
      <span className='text-danger text-end'>
        {'-$' +
          (value * -1).toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')}
      </span>
    );
  else
    return (
      <span className='text-end'>
        {'$' + value.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')}
      </span>
    );
};

export const fileFormatter = (row, download) => {

  const { files } = row;
  if (files && files.length) {
    return files.map((file, index) => {
      return (
        <span
          className='fax-link'
          key={`${file.fileName}${index}`}
          onClick={() => download(file)}
        >
          {file.fileName}
          <br />
        </span>
      );
    });
  }
  return <span>There is no attachment</span>;
};

export const dateFormate = (value) => {

  if (!value) return '-';
  return moment(new Date(value)).format('MM/DD/YYYY hh:mm A');
};

export const dateTimeFormate = (value) => {

  if (!value) return '-';
  var dt = moment(new Date(value)).format('MM/DD/YYYY hh:mm A');
  var strDt = new Date(dt + ' UTC');
  return moment(new Date(strDt)).format('MM/DD/YYYY hh:mm A');
};